// src/events/game-update-events.ts

// Simple event emitter for game updates
type Listener = () => void;

class GameUpdateEventEmitter {
  private listeners: Listener[] = [];
  private _isUpdating = false;
  private _message = '';

  get isUpdating() {
    return this._isUpdating;
  }

  get message() {
    return this._message;
  }

  setUpdating(value: boolean, message = '') {
    this._isUpdating = value;
    this._message = message;
    this.notifyListeners();
  }

  addListener(listener: Listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  private notifyListeners() {
    this.listeners.forEach(listener => listener());
  }
}

// Singleton instance
export const gameUpdateEvents = new GameUpdateEventEmitter();
